import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from '@studio-freight/lenis';
import MouseTrail from './components/MouseTrail';
import HomePage from './pages/HomePage';
import PlaylistShowcase from './pages/PlaylistShowcase';
import './index.css';

function AppContent() {
  const location = useLocation();
  const lenisRef = React.useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.08, // medium smoothing
      wheelMultiplier: 1.1,
      touchMultiplier: 1.0,
      smoothWheel: true,
      smoothTouch: true
    });
    lenisRef.current = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  // Stop Lenis and scroll to top immediately on route change
  useEffect(() => {
    if (lenisRef.current) {
      lenisRef.current.stop();
      window.scrollTo(0, 0);
      // Resume Lenis after a short delay
      setTimeout(() => {
        if (lenisRef.current) {
          lenisRef.current.start();
        }
      }, 100);
    }
  }, [location.pathname]);
  
  return (
    <div className="App w-full">
      <MouseTrail />
      <Routes key={location.pathname}>
        <Route path="/" element={<HomePage />} />
        <Route path="/playlist/:playlistId" element={<PlaylistShowcase />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;